import styled from 'styled-components';

export const StyledSurchargeTable = styled.table `
   border-spacing:0;
   table-layout: fixed; 
   width: 100%;
   margin-bottom: 10px;

   td, th {
      border-color: ${props => props.borderColour ? props.borderColour : 'black'};
      border-style: solid;
      border-width: 1px;
      font-size: 14px;
      overflow: hidden;
      padding: 14px 10px;
      word-break: normal;
      text-align: center;
      vertical-align: middle;
      text-transform: uppercase;
      color: ${props => props.fontColour ? props.fontColour : 'black'};
   }

   .desktop {
      @media only screen and (max-width: 700px) {
         display: none;
      }
   }

   .mobile {
      @media only screen and (min-width: 701px) {
         display: none;
      }
   }
`;

export const StyledHeading = styled.th `
   font-weight: bold;
   background-color: ${props => props.bgColour ? props.bgColour : 'white'};
`;

export const StyledHourlyRates = styled.td `
   background-color: ${props => props.bgColour && props.fontColour ? props.bgColour : 'white'};
   color: ${props => props.fontColour && props.bgColour ? `${props.fontColour} !important` : 'black'};
   text-align: center;
   vertical-align: middle;
   font-weight: 600;
   font-style: normal;
`;

export const StyledSmallText = styled.small `
   font-size: 12px;
   color: #3C3C3B;
`